import React, { useState } from 'react';
import { WorkflowInputLayout } from './WorkflowInputLayout';
import RegulatoryTab from '../../../components/utility_planning/scenarioInputs/RegulatoryTab';

export default function PolicyInputPage() {
  const [data, setData] = useState({ selectedPolicies: [] });
  const updateData = (next) => setData((prev) => ({ ...prev, ...next }));

  return (
    <WorkflowInputLayout title="Policy">
      <div className="bg-white rounded-xl shadow-lg font-ui">
        <RegulatoryTab data={data} updateData={updateData} />
      </div>
    </WorkflowInputLayout>
  );
}
